import { createUserManager } from '@sdb-develop/learning-redux-oidc-es6';

const TENANT_KEY = 'tenant';

const host = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;

const oidcSettings = {
    client_id: 'tcg-composition',
    redirect_uri: `${host}/callback`,
    response_type: 'token id_token',
    scope: 'openid name api',
    authority: 'https://sts.competence.biz/identity',
    silent_redirect_uri: `${host}/silentrenew`,
    post_logout_redirect_uri: `${host}/signedout`,
    automaticSilentRenew: true,
    // Defaults to true, but nothing consumes its events and it polls the STS check
    // session iframe every 2 seconds. Worse, it reports a sign out whenever its own
    // iframe request fails - which is what a blocked third-party cookie looks like -
    // so leaving it on is an endless sign-in loop waiting to happen.
    monitorSession: false,
    filterProtocolClaims: false,
    loadUserInfo: false,
};

export const userManager = createUserManager(oidcSettings);

export const getTenant = () => localStorage.getItem(TENANT_KEY);

export const setTenant = (tenant) => {
    localStorage.setItem(TENANT_KEY, tenant);
};

export const clearTenant = () => {
    localStorage.removeItem(TENANT_KEY);
};
